/* eslint-disable */
import React, { useState, useEffect, useContext } from 'react';
import { Table, Pagination, Select, Modal, Input, message, Checkbox, Button as AntdButton, Dropdown, Menu, Radio } from 'antd';
import {
  AppBar,
  Toolbar,
  Grid,
  Box,
  Button,
} from '@mui/material';
import SortIcon from '@mui/icons-material/Sort';
import FilterListIcon from '@mui/icons-material/FilterList';
import SaveIcon from '@mui/icons-material/Save';
import LoadIcon from '@mui/icons-material/Download';
import ScheduleIcon from '@mui/icons-material/Schedule';
import ViewColumnIcon from '@mui/icons-material/ViewColumn';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import SaveAltIcon from '@mui/icons-material/SaveAlt';
import { styled } from '@mui/system';
import 'antd/dist/reset.css'; // Ant Design CSS reset dosyasını import ediyoruz
import './References.css'; // Özel stilleri burada kullanacağız
import { useAuth } from 'context/AuthWizardContext';
import { saveAs } from 'file-saver';
import * as XLSX from 'xlsx';
import jsPDF from 'jspdf';
import 'jspdf-autotable';

const { Option } = Select;

const ToolbarContainer = styled(Box)({
  flexGrow: 1,
  marginBottom: '2vh',
  borderRadius: '0.5vh',
  border: '0.1vh solid #e0e0e0',
  boxShadow: '0px 0.5vh 0.75vh rgba(0, 0, 0, 0.1)',
});

const ButtonContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  gap: theme.spacing(1),
  [theme.breakpoints.down('sm')]: {
    flexDirection: 'column',
  },
  [theme.breakpoints.up('md')]: {
    flexDirection: 'row',
  },
}));

const CustomButton = styled(Button)(({ theme }) => ({
  margin: theme.spacing(0.5),
  '&.sort-filter-columns': {
    backgroundColor: '#f5f5f5',
    color: '#000',
    borderColor: '#e0e0e0',
    '&:hover': {
      backgroundColor: '#e0e0e0',
      borderColor: '#d0d0d0',
    },
  },
  '&.export-button': {
    backgroundColor: '#4CAF50',
    color: '#fff',
    borderColor: '#4CAF50',
    '&:hover': {
      backgroundColor: '#45A049',
      borderColor: '#45A049',
    },
  },
  '&.apply-button': {
    backgroundColor: '#FF5722',
    color: '#fff',
    borderColor: '#FF5722',
    '&:hover': {
      backgroundColor: '#E64A19',
      borderColor: '#E64A19',
    },
  },
  '&.save-variant-button': {
    backgroundColor: '#2196F3',
    color: '#fff',
    borderColor: '#2196F3',
    '&:hover': {
      backgroundColor: '#1976D2',
      borderColor: '#1976D2',
    },
  },
  '&.load-variant-button': {
    backgroundColor: '#FFC107',
    color: '#fff',
    borderColor: '#FFC107',
    '&:hover': {
      backgroundColor: '#FFB300',
      borderColor: '#FFB300',
    },
  },
  '&.set-schedule-button': {
    backgroundColor: '#9C27B0',
    color: '#fff',
    borderColor: '#9C27B0',
    '&:hover': {
      backgroundColor: '#8E24AA',
      borderColor: '#8E24AA',
    },
  },
}));

const References = () => {
  const [data, setData] = useState([]);
  const [total, setTotal] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setPerPage] = useState(20);
  const [loading, setLoading] = useState(false);
  const [columns, setColumns] = useState([]);
  const [headerList, setHeaderList] = useState([]);
  const [visibleColumns, setVisibleColumns] = useState([]);
  const [sortModalVisible, setSortModalVisible] = useState(false);
  const [filterModalVisible, setFilterModalVisible] = useState(false);
  const [columnsModalVisible, setColumnsModalVisible] = useState(false);
  const [sortCriteria, setSortCriteria] = useState([]);
  const [filterCriteria, setFilterCriteria] = useState([]);
  const [variantModalVisible, setVariantModalVisible] = useState(false);
  const [variants, setVariants] = useState([]);
  const [saveVariantModalVisible, setSaveVariantModalVisible] = useState(false);
  const [variantName, setVariantName] = useState('');
  const [selectedColumns, setSelectedColumns] = useState([]);
  const [availableColumns, setAvailableColumns] = useState([]);
  const [defaultVariant, setDefaultVariant] = useState(null); // Default variant state
  const { user } = useAuth();

  const fetchData = async (page, perPage, sort = [], filter = []) => {
    setLoading(true);
    // try {
    //   const response = await fetch(process.env.REACT_APP_API_URL, {
    //     method: 'POST',
    //     headers: {
    //       'Content-Type': 'application/json',
    //     },
    //     body: JSON.stringify({
    //       process: '100019270',
    //       page: page,
    //       per_page: perPage,
    //       sort,
    //       filter,
    //     }),
    //     credentials: 'include',
    //     mode: 'cors'
    //   });
    //   const result = await response.json();

    //   // Header listesi ve sütunları ayarla
    //   const headers = result.headerList;
    //   setHeaderList(headers); // Header listesi set ediliyor
    //   setAvailableColumns(headers.filter(header => !selectedColumns.includes(header))); // Available columns listesi
    //   const dynamicColumns = headers.map((header) => ({
    //     title: <div>{header}</div>,
    //     dataIndex: header,
    //     key: header,
    //     sorter: (a, b) => a[header].localeCompare(b[header]), // Sıralama fonksiyonu
    //     sortDirections: ['ascend', 'descend'], // Sıralama yönleri
    //   }));
    //   setColumns(dynamicColumns);

    //   // Verileri ve toplam sayıyı ayarla
    //   const modifiedData = result.raws.map((item) => ({
    //     ...item,
    //     _id: item._id.$oid, // _id alanını metin olarak işleyin
    //   }));
    //   setData(modifiedData);

    //   // Toplam sayfa sayısını hesapla
    //   const totalItems = result.raws_count; // API'den gelen toplam döküman sayısı
    //   setTotal(totalItems);

    //   console.log('Total Items:', totalItems); // Toplam döküman sayısını konsola yazdır
    // } catch (error) {
    //   console.error('Veri alınırken hata oluştu', error);
    // }
    setLoading(false);
  };

  useEffect(() => {
    fetchData(currentPage, perPage, sortCriteria, filterCriteria);
  }, [currentPage, perPage, sortCriteria, filterCriteria]);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handlePerPageChange = (value) => {
    setPerPage(value);
    setCurrentPage(1); // Sayfa başına gösterilen veri sayısı değiştiğinde ilk sayfaya dön
  };

  const handleSortModalOk = () => {
    setSortModalVisible(false);
  };

  const handleFilterModalOk = () => {
    setFilterModalVisible(false);
  };

  const handleVariantModalOk = async () => {
    setVariantModalVisible(false);
    console.log(defaultVariant)
    // Sunucuya istek at
    // try {
    //   const response = await fetch(process.env.REACT_APP_API_URL, {
    //     method: 'POST',
    //     headers: {
    //       'Content-Type': 'application/json',
    //     },
    //     body: JSON.stringify({
    //       process: '100019297',
    //       reportId: '100019270',
    //       variantName: defaultVariant,
    //     }),
    //     credentials: 'include',
    //     mode: 'cors'
    //   });
    //   const result = await response.json();
    //   if (response.status === 200) {
    //     message.success('Default variant successfully set');
    //   } else {
    //     message.error('Failed to set default variant');
    //   }
    // } catch (error) {
    //   console.error('Error setting default variant', error);
    //   message.error('Error setting default variant');
    // }
  };

  const handleColumnsModalOk = () => {
    const dynamicColumns = selectedColumns.map((header) => ({
      title: <div>{header}</div>,
      dataIndex: header,
      key: header,
      sorter: (a, b) => a[header].localeCompare(b[header]), // Sıralama fonksiyonu
      sortDirections: ['ascend', 'descend'], // Sıralama yönleri
    }));
    setColumns(dynamicColumns);
    setColumnsModalVisible(false);
  };

  const applyCriteria = async () => {
    const requestBody = {
      process: "100019270",
      page: currentPage,
      per_page: perPage,
      reportId: 100019270,
      filterCriteria,
      sortCriteria: sortCriteria.reduce((acc, cur) => ({ ...acc, [cur.field]: cur.type === 'asc' ? 1 : -1 }), {}),
      columnCriteria: selectedColumns.reduce((acc, cur) => ({ ...acc, [cur]: 1 }), {})
    };

    console.log(requestBody);

    setLoading(true);
    // try {
    //   const response = await fetch(process.env.REACT_APP_API_URL, {
    //     method: 'POST',
    //     headers: {
    //       'Content-Type': 'application/json',
    //     },
    //     body: JSON.stringify(requestBody),
    //     credentials: 'include',
    //     mode: 'cors'
    //   });
    //   const result = await response.json();

    //   // Header listesi ve sütunları ayarla
    //   const headers = result.headerList;
    //   setHeaderList(headers); // Header listesi set ediliyor
    //   setAvailableColumns(headers.filter(header => !selectedColumns.includes(header))); // Available columns listesi
    //   const dynamicColumns = headers.map((header) => ({
    //     title: <div>{header}</div>,
    //     dataIndex: header,
    //     key: header,
    //     sorter: (a, b) => a[header].localeCompare(b[header]), // Sıralama fonksiyonu
    //     sortDirections: ['ascend', 'descend'], // Sıralama yönleri
    //   }));
    //   setColumns(dynamicColumns);

    //   // Verileri ve toplam sayıyı ayarla
    //   const modifiedData = result.raws.map((item) => ({
    //     ...item,
    //     _id: item._id.$oid, // _id alanını metin olarak işleyin
    //   }));
    //   setData(modifiedData);

    //   // Toplam sayfa sayısını hesapla
    //   const totalItems = result.raws_count; // API'den gelen toplam döküman sayısı
    //   setTotal(totalItems);

    //   console.log('Total Items:', totalItems); // Toplam döküman sayısını konsola yazdır
    // } catch (error) {
    //   console.error('Veri alınırken hata oluştu', error);
    // }
    setLoading(false);
  };

  const saveVariant = async () => {
    // try {
    //   const response = await fetch(process.env.REACT_APP_API_URL, {
    //     method: 'POST',
    //     headers: {
    //       'Content-Type': 'application/json',
    //     },
    //     body: JSON.stringify({
    //       process: '100019295',
    //       variantName,
    //       sortCriteria,
    //       filterCriteria,
    //       columnCriteria: selectedColumns,
    //       reportId: '100019270',
    //     }),
    //     credentials: 'include',
    //     mode: 'cors'
    //   });
    //   const result = await response.json();
    //   console.log(result);
    //   console.log(sortCriteria);
    //   console.log(filterCriteria);
    //   if (response.status === 200) {
    //     message.success('Variants successfully saved');
    //   } else {
    //     message.error('Failed to save variants');
    //   }
    //   setSaveVariantModalVisible(false);
    // } catch (error) {
    //   console.error('Error saving variants', error);
    //   message.error('Error saving variants');
    // }
  };

  const loadVariants = async () => {
    // try {
    //   const response = await fetch(process.env.REACT_APP_API_URL, {
    //     method: 'POST',
    //     headers: {
    //       'Content-Type': 'application/json',
    //     },
    //     body: JSON.stringify({
    //       process: '100019296',
    //     }),
    //     credentials: 'include',
    //     mode: 'cors'
    //   });
    //   const result = await response.json();
    //   console.log(result);
    //   setVariants(result.variants);
    //   const defaultVariant = result.variants.find(variant => variant.default === 1);
    //   if (defaultVariant) {
    //     setDefaultVariant(defaultVariant._id.$oid);
    //   }
    //   setVariantModalVisible(true);
    // } catch (error) {
    //   console.error('Error loading variants', error);
    // }
  };

  const applyVariant = (variant) => {
    setSortCriteria(variant.sortCriteria);
    setFilterCriteria(variant.filterCriteria);
    setSelectedColumns(variant.visibleColumns);
    setColumnsModalVisible(false);
    setVariantModalVisible(false);
  };

  const handleAddColumn = (headerToAdd) => {
    setSelectedColumns([...selectedColumns, headerToAdd]);
    setAvailableColumns(availableColumns.filter(header => header !== headerToAdd));
  };

  const handleRemoveColumn = (headerToRemove) => {
    setAvailableColumns([...availableColumns, headerToRemove]);
    setSelectedColumns(selectedColumns.filter(header => header !== headerToRemove));
  };

  const moveColumnUp = (index) => {
    if (index === 0) return;
    const newSelectedColumns = [...selectedColumns];
    const temp = newSelectedColumns[index - 1];
    newSelectedColumns[index - 1] = newSelectedColumns[index];
    newSelectedColumns[index] = temp;
    setSelectedColumns(newSelectedColumns);
  };

  const moveColumnDown = (index) => {
    if (index === selectedColumns.length - 1) return;
    const newSelectedColumns = [...selectedColumns];
    const temp = newSelectedColumns[index + 1];
    newSelectedColumns[index + 1] = newSelectedColumns[index];
    newSelectedColumns[index] = temp;
    setSelectedColumns(newSelectedColumns);
  };

  const exportToCSV = () => {
    const headers = headerList.join(',');
    const csvData = data.map(row => headerList.map(field => `"${row[field] || ''}"`).join(',')).join('\r\n');
    const csvBlob = new Blob([`${headers}\r\n${csvData}`], { type: 'text/csv;charset=utf-8;' });
    saveAs(csvBlob, 'data.csv');
  };

  const exportToXLSX = () => {
    const worksheet = XLSX.utils.json_to_sheet(data, { header: headerList });
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Data');
    XLSX.writeFile(workbook, 'data.xlsx');
  };

  const exportToPDF = () => {
    const doc = new jsPDF();
    doc.autoTable({
      head: [headerList],
      body: data.map(row => headerList.map(field => row[field])),
    });
    doc.save('data.pdf');
  };

  const exportMenu = (
    <Menu>
      <Menu.Item key="1" onClick={exportToCSV}>Export CSV</Menu.Item>
      <Menu.Item key="2" onClick={exportToXLSX}>Export XLSX</Menu.Item>
      <Menu.Item key="3" onClick={exportToPDF}>Export PDF</Menu.Item>
    </Menu>
  );

  return (
    <div>
      <ToolbarContainer>
        <AppBar position="static" style={{ backgroundColor: '#f5f5f5' }}>
          <Toolbar>
            <Grid container spacing={2} alignItems="center">
              <Grid item xs={12} md={8} container justifyContent="flex-start">
                <ButtonContainer>
                  <CustomButton onClick={() => setSortModalVisible(true)} startIcon={<SortIcon />} variant="contained" className="sort-filter-columns">
                    Sort
                  </CustomButton>
                  <CustomButton onClick={() => setFilterModalVisible(true)} startIcon={<FilterListIcon />} variant="contained" className="sort-filter-columns">
                    Filter
                  </CustomButton>
                  <CustomButton onClick={() => setColumnsModalVisible(true)} startIcon={<ViewColumnIcon />} variant="contained" className="sort-filter-columns">
                    Columns
                  </CustomButton>
                  <CustomButton onClick={applyCriteria} startIcon={<SaveIcon />} variant="contained" className="apply-button">
                    Apply
                  </CustomButton>
                  <CustomButton onClick={() => setSaveVariantModalVisible(true)} startIcon={<SaveIcon />} variant="contained" className="save-variant-button">
                    Save Variant
                  </CustomButton>
                  <CustomButton onClick={loadVariants} startIcon={<LoadIcon />} variant="contained" className="load-variant-button">
                    Load Variant
                  </CustomButton>
                  <CustomButton onClick={() => message.info('Set Schedule clicked')} startIcon={<ScheduleIcon />} variant="contained" className="set-schedule-button">
                    Set Schedule
                  </CustomButton>
                  <Dropdown overlay={exportMenu} trigger={['click']}>
                    <CustomButton startIcon={<SaveAltIcon />} variant="contained" className="export-button">
                      Export
                    </CustomButton>
                  </Dropdown>
                </ButtonContainer>
                <div style={{ color: 'black', marginLeft: '1rem' }}>{user.user}</div>
              </Grid>
              <Grid item xs={12} className='mt-2' md={4} container justifyContent="flex-end">
                <Grid container alignItems="center" spacing={2} justifyContent="flex-end">
                  <Grid item>
                    <Pagination
                      current={currentPage}
                      total={total}
                      pageSize={perPage}
                      onChange={handlePageChange}
                      showSizeChanger={false}
                    />
                  </Grid>
                  <Grid item>
                    <Select defaultValue={20} style={{ width: '15vw' }} onChange={handlePerPageChange}>
                      <Option value={20}>20</Option>
                      <Option value={50}>50</Option>
                      <Option value={100}>100</Option>
                      <Option value={150}>150</Option>
                    </Select>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Toolbar>
        </AppBar>
      </ToolbarContainer>

      <Table
        columns={columns}
        dataSource={data}
        pagination={false}
        loading={loading}
        rowKey={(record) => record._id}
        bordered
        scroll={{ x: '100%' }} // Yatay kaydırma eklemek için
        size="small" // Küçük boyut
      />

      <Modal
        title="Sort Criteria"
        visible={sortModalVisible}
        onOk={handleSortModalOk}
        onCancel={() => setSortModalVisible(false)}
        width="80vw" // Modal genişliğini artırıyoruz
      >
        <Table
          dataSource={sortCriteria}
          columns={[
            { title: 'INDEX', dataIndex: 'index', key: 'index' },
            {
              title: 'FIELD', dataIndex: 'field', key: 'field', render: (text, record) => (
                <Select value={text} onChange={(value) => {
                  const newCriteria = sortCriteria.map(item => {
                    if (item.index === record.index) {
                      return { ...item, field: value };
                    }
                    return item;
                  });
                  setSortCriteria(newCriteria);
                }} style={{ width: '100%' }}>
                  {headerList.map(header => (
                    <Option key={header} value={header}>{header}</Option>
                  ))}
                </Select>
              )
            },
            {
              title: 'TYPE', dataIndex: 'type', key: 'type', render: (text, record) => (
                <Select value={text} onChange={(value) => {
                  const newCriteria = sortCriteria.map(item => {
                    if (item.index === record.index) {
                      return { ...item, type: value };
                    }
                    return item;
                  });
                  setSortCriteria(newCriteria);
                }} style={{ width: '100%' }}>
                  <Option value="asc">Asc</Option>
                  <Option value="desc">Desc</Option>
                </Select>
              )
            },
            {
              title: 'OPTION', dataIndex: 'option', key: 'option', render: (_, record) => (
                <Button onClick={() => setSortCriteria(sortCriteria.filter(item => item.index !== record.index))}>Delete</Button>
              )
            },
          ]}
          pagination={false}
          rowKey="index"
          size="large" // Tablo boyutunu büyütüyoruz
        />
        <CustomButton onClick={() => setSortCriteria([...sortCriteria, { index: sortCriteria.length + 1, field: '', type: '', option: 'Delete' }])}>EKLE</CustomButton>
      </Modal>

      <Modal
        title="Filter Criteria"
        visible={filterModalVisible}
        onOk={handleFilterModalOk}
        onCancel={() => setFilterModalVisible(false)}
        width="80vw" // Modal genişliğini artırıyoruz
      >
        <Table
          dataSource={filterCriteria}
          columns={[
            { title: 'INDEX', dataIndex: 'index', key: 'index' },
            {
              title: 'FIELD', dataIndex: 'field', key: 'field', render: (text, record) => (
                <Select value={text} onChange={(value) => {
                  const newCriteria = filterCriteria.map(item => {
                    if (item.index === record.index) {
                      return { ...item, field: value };
                    }
                    return item;
                  });
                  setFilterCriteria(newCriteria);
                }} style={{ width: '100%' }}>
                  {headerList.map(header => (
                    <Option key={header} value={header}>{header}</Option>
                  ))}
                </Select>
              )
            },
            {
              title: 'OPERATÖR', dataIndex: 'operator', key: 'operator', render: (text, record) => (
                <Select value={text} onChange={(value) => {
                  const newCriteria = filterCriteria.map(item => {
                    if (item.index === record.index) {
                      return { ...item, operator: value };
                    }
                    return item;
                  });
                  setFilterCriteria(newCriteria);
                }} style={{ width: '100%' }}>
                  <Option value="=">=</Option>
                  <Option value="!=">!=</Option>
                  <Option value=">">&gt;</Option>
                  <Option value="<">&lt;</Option>
                  <Option value=">=">&gt;=</Option>
                  <Option value="<=">&lt;=</Option>
                  <Option value="between">Between</Option>
                </Select>
              )
            },
            {
              title: 'VALUE', dataIndex: 'value', key: 'value', render: (text, record) => (
                <Input value={text} onChange={(e) => {
                  const newCriteria = filterCriteria.map(item => {
                    if (item.index === record.index) {
                      return { ...item, value: e.target.value };
                    }
                    return item;
                  });
                  setFilterCriteria(newCriteria);
                }} style={{ width: '100%' }} />
              )
            },
            {
              title: 'OPTION', dataIndex: 'option', key: 'option', render: (_, record) => (
                <Button onClick={() => setFilterCriteria(filterCriteria.filter(item => item.index !== record.index))}>Delete</Button>
              )
            },
          ]}
          pagination={false}
          rowKey="index"
          size="large" // Tablo boyutunu büyütüyoruz
        />
        <CustomButton onClick={() => setFilterCriteria([...filterCriteria, { index: filterCriteria.length + 1, field: '', operator: '', value: '', option: 'Delete' }])}>EKLE</CustomButton>
      </Modal>

      <Modal
        title="Load Variant"
        visible={variantModalVisible}
        onOk={handleVariantModalOk}
        onCancel={() => setVariantModalVisible(false)}
        width="80vw" // Modal genişliğini artırıyoruz
        style={{ top: 20 }}
        bodyStyle={{ padding: '20px' }}
      >
        <Grid container spacing={2} style={{ minHeight: '50vh' }}>
          <Grid item xs={12} md={4} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <Radio.Group
              value={defaultVariant}
              onChange={(e) => setDefaultVariant(e.target.value)}
              style={{ width: '100%' }}
            >
              {variants.map((variant) => (
                <Radio key={variant._id.$oid} value={variant._id.$oid}>
                  {variant.variantName}
                  {variant.default === 1 && ' (Default Variant)'}
                </Radio>
              ))}
            </Radio.Group>
          </Grid>
          <Grid item xs={12} md={8}>
            <Table
              dataSource={variants}
              columns={[
                { title: 'NAME', dataIndex: 'variantName', key: 'variantName' },
                {
                  title: 'DEFAULT',
                  key: 'default',
                  render: (_, variant) => (
                    <div>
                      <Radio value={variant._id.$oid} />
                      {variant.default === 1 && ' (Default Variant)'}
                    </div>
                  ),
                },
                {
                  title: 'ACTION',
                  key: 'action',
                  render: (_, variant) => (
                    <Button onClick={() => applyVariant(variant)}>Select</Button>
                  ),
                },
              ]}
              pagination={false}
              rowKey="_id.$oid"
              size="large"
              expandable={{
                expandedRowRender: (variant) => (
                  <>
                    <h4>Sort Criteria</h4>
                    <Table
                      dataSource={variant.sortCriteria}
                      columns={[
                        { title: 'Index', dataIndex: 'index', key: 'index' },
                        { title: 'Field', dataIndex: 'field', key: 'field' },
                        { title: 'Type', dataIndex: 'type', key: 'type' },
                      ]}
                      pagination={false}
                      rowKey="index"
                      size="small"
                    />
                    <h4>Filter Criteria</h4>
                    <Table
                      dataSource={variant.filterCriteria}
                      columns={[
                        { title: 'Index', dataIndex: 'index', key: 'index' },
                        { title: 'Field', dataIndex: 'field', key: 'field' },
                        { title: 'Operator', dataIndex: 'operator', key: 'operator' },
                        { title: 'Value', dataIndex: 'value', key: 'value' },
                      ]}
                      pagination={false}
                      rowKey="index"
                      size="small"
                    />
                  </>
                ),
              }}
            />
          </Grid>
        </Grid>
      </Modal>

      <Modal
        title="Save Variant"
        visible={saveVariantModalVisible}
        onCancel={() => setSaveVariantModalVisible(false)}
        footer={null}
        width="80vw" // Modal genişliğini artırıyoruz
      >
        <div>
          <Table
            dataSource={sortCriteria}
            columns={[
              { title: 'INDEX', dataIndex: 'index', key: 'index' },
              { title: 'FIELD', dataIndex: 'field', key: 'field' },
              { title: 'TYPE', dataIndex: 'type', key: 'type' },
            ]}
            pagination={false}
            rowKey="index"
            size="large" // Tablo boyutunu büyütüyoruz
          />
          <Table
            dataSource={filterCriteria}
            columns={[
              { title: 'INDEX', dataIndex: 'index', key: 'index' },
              { title: 'FIELD', dataIndex: 'field', key: 'field' },
              { title: 'OPERATOR', dataIndex: 'operator', key: 'operator' },
              { title: 'VALUE', dataIndex: 'value', key: 'value' },
            ]}
            pagination={false}
            rowKey="index"
            size="large" // Tablo boyutunu büyütüyoruz
          />
          <Table
            dataSource={selectedColumns.map((col, index) => ({ index, col }))}
            columns={[
              { title: 'INDEX', dataIndex: 'index', key: 'index' },
              { title: 'COLUMN', dataIndex: 'col', key: 'col' },
            ]}
            pagination={false}
            rowKey="index"
            size="large" // Tablo boyutunu büyütüyoruz
          />
          <Input
            placeholder="Variant Name"
            value={variantName}
            onChange={(e) => setVariantName(e.target.value)}
            style={{ marginTop: '2vh' }}
          />
          <div style={{ marginTop: '2vh', textAlign: 'right' }}>
            <Button onClick={saveVariant} type="primary">
              Save
            </Button>
            <Button onClick={() => setSaveVariantModalVisible(false)} style={{ marginLeft: '1vh' }}>
              Cancel
            </Button>
          </div>
        </div>
      </Modal>

      <Modal
        title="Manage Columns"
        visible={columnsModalVisible}
        onOk={handleColumnsModalOk}
        onCancel={() => setColumnsModalVisible(false)}
        width="80vw" // Modal genişliğini artırıyoruz
      >
        <Grid container spacing={2}>
          <Grid item xs={5}>
            <h3>Available Columns</h3>
            <div style={{ maxHeight: '50vh', overflowY: 'scroll', border: '1px solid #e0e0e0', borderRadius: '4px', padding: '1vh' }}>
              {availableColumns.map(header => (
                <div key={header} style={{ padding: '1vh 0', borderBottom: '1px solid #e0e0e0' }}>
                  <Checkbox onChange={() => handleAddColumn(header)}>
                    {header}
                  </Checkbox>
                </div>
              ))}
            </div>
          </Grid>
          <Grid item xs={2} container direction="column" alignItems="center" justifyContent="center">
            <CustomButton onClick={() => setSelectedColumns([...selectedColumns, ...availableColumns])} variant="contained" color="primary">
              Add All {'>>'}
            </CustomButton>
            <CustomButton onClick={() => setSelectedColumns([])} variant="contained" color="secondary">
              Remove All {'<<'}
            </CustomButton>
          </Grid>
          <Grid item xs={5}>
            <h3>Selected Columns</h3>
            <div style={{ maxHeight: '50vh', overflowY: 'scroll', border: '1px solid #e0e0e0', borderRadius: '4px', padding: '1vh' }}>
              {selectedColumns.map((header, index) => (
                <div key={header} style={{ padding: '1vh 0', borderBottom: '1px solid #e0e0e0', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                  <Checkbox checked onChange={() => handleRemoveColumn(header)}>
                    {header}
                  </Checkbox>
                  <div>
                    <Button onClick={() => moveColumnUp(index)} disabled={index === 0}>
                      <ArrowUpwardIcon />
                    </Button>
                    <Button onClick={() => moveColumnDown(index)} disabled={index === selectedColumns.length - 1}>
                      <ArrowDownwardIcon />
                    </Button>
                  </div>
                </div>
              ))}
            </div>
          </Grid>
        </Grid>
      </Modal>
    </div>
  );
};

export default References;
